import { ListItem } from '../../core/models/list-item';
import * as actions from '../actions/search';
import * as docActions from '../../document/actions/document';
import { SearchCriteria } from '../models/search-criteria';
import { SearchResult } from '../models/search-result';
import { DocumentDetail } from '../models/document-detail';
import { DocumentMaster } from 'app/modules/document/models/document-master';

export interface State {
  loading: boolean;
  criteria: SearchCriteria;
  results: SearchResult[];
  detail: DocumentDetail;
  glennDale: DocumentMaster[];
}

export const initialState: State = {
  loading: false,
  criteria: {},
  results: [],
  detail: {},
  glennDale: []
};

export function reducer(state = initialState, action: any): State {
  let newState: State;

  switch (action.type) {

    case actions.SEARCH_DOCUMENTS:
      newState = Object.assign({}, state);
      newState.loading = true;
      newState.criteria = action.payload;
      return newState;

    case actions.SEARCH_DOCUMENTS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.results = action.payload;
      return newState;

    case actions.DOWNLOAD_FILE:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.DOWNLOAD_FILE_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      return newState;

    case actions.LOAD_DOCUMENT_DETAIL:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.LOAD_DOCUMENT_DETAIL_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.detail = action.payload;
      return newState;

    case actions.UPSERT_DOCUMENT_METADATA:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.UPSERT_DOCUMENT_METADATA_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.detail = {};
      return newState;

    case docActions.UPLOAD_FILE_COMPLETE:
      newState = Object.assign({}, state);
      const detail = Object.assign({}, newState.detail)
      detail.filename = action.payload.value;
      detail.downloadId = action.payload.id;
      newState.detail = Object.assign({}, detail);
      return newState;

    case actions.CLEAR_DOCUMENT_DETAIL:
      newState = Object.assign({}, state);
      newState.detail = {};
      return newState;

    case actions.LOAD_GLENN_DALE_DOCUMENTS:
      newState = Object.assign({}, state);
      newState.loading = true;
      return newState;

    case actions.LOAD_GLENN_DALE_DOCUMENTS_COMPLETE:
      newState = Object.assign({}, state);
      newState.loading = false;
      newState.glennDale = action.payload;
      return newState;

    case 'ERROR':
      newState = Object.assign({}, state);
      newState.loading = false;
      return newState;

      default:
      newState = Object.assign({}, state);
      return newState;
  }
}

export const criteria = (state: State) => state.criteria;
export const loading = (state: State) => state.loading;
export const resultCount = (state: State) => state.results.length || 0;
export const results = (state: State) => state.results;
export const detail = (state: State) => state.detail;
export const glennDale = (state: State) => state.glennDale;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/reducers/search.ts